import { useState, useEffect } from "react";
import { MapGeoJSON, MapProtectedRainforestArea } from "types/map";
import { calculateGeoJSONArea } from "libraries/map";
import protectedAreasData from "json/protectedAreas.json";

const FORECO_DATA = protectedAreasData[0];

export const useMapForecoFetchAreas = () => {
  const [protectedRegions, setProtectedRegions] = useState<
    Array<MapProtectedRainforestArea>
  >([]);
  const [protectedCorridors, setProtectedCorridors] = useState<
    Array<MapProtectedRainforestArea>
  >([]);
  const [protectedHumans, setProtectedHumans] = useState<
    Array<MapProtectedRainforestArea>
  >([]);

  useEffect(() => {
    const fetchAreas = async () => {
      const promises = FORECO_DATA.rainforestRegions.map((area: any) =>
        fetch(area.geoAreaFile)
          .then((res) => res.json())
          .then((data) => ({
            name: area.name,
            areaStrokeColor: area.areaStrokeColor,
            areaFillColor: area.areaFillColor,
            geoJSON: data as MapGeoJSON,
            squareFootage: area.squareFootage ?? calculateGeoJSONArea(data as MapGeoJSON),
            details: area.details,
            defaultHidden: area.defaultHidden,
            picture: area.picture,
          }))
      );

      const results = await Promise.all(promises);
      setProtectedRegions(results);

      if ((FORECO_DATA as any).rainforestCorridors) {
        const corridorPromises = (FORECO_DATA as any).rainforestCorridors.map(
          (area: any) =>
            fetch(area.geoAreaFile)
              .then((res) => res.json())
              .then((data) => ({
                name: area.name,
                areaStrokeColor: area.areaStrokeColor,
                areaFillColor: area.areaFillColor,
                geoJSON: data as MapGeoJSON,
                squareFootage: area.squareFootage ?? calculateGeoJSONArea(data as MapGeoJSON),
                details: area.details,
                defaultHidden: area.defaultHidden,
                picture: area.picture,
              }))
        );

        const corridorResults = await Promise.all(corridorPromises);
        setProtectedCorridors(corridorResults);
      }

      if ((FORECO_DATA as any).rainforestHumans) {
        const humanPromises = (FORECO_DATA as any).rainforestHumans.map(
          (area: any) =>
            fetch(area.geoAreaFile)
              .then((res) => res.json())
              .then((data) => ({
                name: area.name,
                areaStrokeColor: area.areaStrokeColor,
                areaFillColor: area.areaFillColor,
                geoJSON: data as MapGeoJSON,
                squareFootage: area.squareFootage ?? calculateGeoJSONArea(data as MapGeoJSON),
                details: area.details,
                defaultHidden: area.defaultHidden,
                picture: area.picture,
              }))
        );

        const humanResults = await Promise.all(humanPromises);
        setProtectedHumans(humanResults);
      }
    };

    fetchAreas();
  }, []);

  return {
    protectedRegions,
    protectedCorridors,
    protectedHumans,
  };
};
